import React, { createContext, useContext, useState, useEffect } from 'react';

const translations = {
  es: {
    // Header
    nav: {
      inicio: 'Inicio',
      servicios: 'Servicios',
      proyectos: 'Proyectos',
      nosotros: 'Nosotros',
      contacto: 'Contacto',
    },
    // Hero
    hero: {
      title1: 'Orquestando lo',
      title2: 'Invisible',
      subtitle: 'Transformando espacios en experiencias inteligentes a través de la domótica de última generación',
      exploreServices: 'Explorar Servicios',
      viewProjects: 'Ver Proyectos',
    },
    // Services
    services: {
      sectionTitle: 'Resumen de Servicios',
      title1: 'Orquestando Tu',
      title2: 'Entorno',
      subtitle: 'Soluciones integrales de automatización que transforman su espacio en un ecosistema inteligente',
      moreInfo: 'Más Info',
      viewDetails: 'Ver Detalles',
      ourSpecialties: 'Nuestras Especialidades',
      allServices: 'Todos Nuestros Servicios',
      detailsTitle: 'Detalles de Servicios',
      moreInformation: 'Más Información',
      pageTitle: 'Nuestros Servicios',
      pageSubtitle: 'Soluciones completas de domótica y automatización para espacios inteligentes',
      // Service titles
      service1: 'Proyectos Integrales',
      service2: 'Iluminación Inteligente',
      service3: 'Sistemas Audiovisuales',
      service4: 'Automatización y Control',
      service5: 'Cines Privados',
      // Service descriptions
      service1Desc: 'Desarrollamos soluciones completas que abarcan todos los aspectos de la automatización moderna.',
      service2Desc: 'Diseñamos sistemas de iluminación que transforman ambientes y optimizan el consumo energético.',
      service3Desc: 'Implementamos tecnología de entretenimiento de vanguardia que ofrece experiencias inmersivas.',
      service4Desc: 'Instalamos sistemas de domótica que centralizan el control de todos los elementos de su espacio.',
      service5Desc: 'Creamos experiencias cinematográficas exclusivas en la comodidad de su hogar.',
      // Sub-services
      integratedLighting: 'Iluminación Integrada',
      multiZoneAudio: 'Audio Multizona',
      climate: 'Climatización',
      security: 'Seguridad',
      naturalLight: 'Luz Natural',
      colorControl: 'Control de Color',
      energySaving: 'Ahorro Energético',
      smartScenes: 'Escenas Inteligentes',
      homeCinema: 'Cine en Casa',
      multiRoomAudio: 'Audio Multiroom',
      videoStreaming: 'Video Streaming',
      soundDesign: 'Diseño de Sonido',
      securitySystem: 'Sistema de Seguridad',
      smartLocks: 'Cerraduras Inteligentes',
      climateControl: 'Control Climático',
      smartBlinds: 'Persianas Inteligentes',
      laserProjection: 'Proyección Láser',
      dolbyAtmos: 'Dolby Atmos',
      premiumSeats: 'Butacas Premium',
      totalControl: 'Control Total',
    },
    // Projects
    projects: {
      sectionTitle: 'Portafolio de Proyectos',
      title1: 'Proyectos que',
      title2: 'Inspiran',
      subtitle: 'Descubra cómo hemos transformado espacios en experiencias inteligentes',
      viewAll: 'Ver Todos los Proyectos',
      pageTitle: 'Nuestros Proyectos',
      pageSubtitle: 'Espacios transformados en experiencias inteligentes',
      all: 'Todos',
      noProjects: 'No hay proyectos en esta categoría',
      projectDescription: 'Descripción del Proyecto',
      brandsUsed: 'Marcas Utilizadas',
      requestInfo: 'Solicitar Información',
      close: 'Cerrar',
    },
    // About
    about: {
      sectionTitle: 'Sobre Nosotros',
      title1: 'Excelencia en',
      title2: 'Automatización',
      description: 'Con más de una década de experiencia, somos líderes en soluciones de domótica de alta gama.',
      stats: {
        projects: 'Proyectos',
        experience: 'Años de Experiencia',
        clients: 'Clientes Satisfechos',
        support: 'Soporte 24/7',
      },
    },
    // Contact
    contact: {
      sectionTitle: 'Contacto',
      title1: 'Hablemos de su',
      title2: 'Proyecto',
      subtitle: 'Estamos aquí para convertir sus ideas en realidad',
      form: {
        name: 'Nombre completo',
        phone: 'Teléfono',
        email: 'Email',
        message: 'Mensaje',
        messagePlaceholder: 'Cuéntenos sobre su proyecto...',
        acceptTerms: 'Acepto los términos y condiciones y la política de privacidad',
        acceptMarketing: 'Acepto recibir comunicaciones comerciales',
        submit: 'Enviar Mensaje',
        sending: 'Enviando...',
      },
      info: {
        title: 'Información de Contacto',
        address: 'Dirección',
        phone: 'Teléfono',
        email: 'Email',
        hours: 'Horario de Atención',
        hoursValue: 'Lun - Vie: 9:00 - 18:00',
      },
    },
    // Footer
    footer: {
      description: 'Expertos en domótica y automatización del hogar de alta gama. Transformamos espacios en experiencias inteligentes.',
      quickLinks: 'Enlaces Rápidos',
      services: 'Servicios',
      contact: 'Síguenos',
      legal: 'Legal',
      privacy: 'Política de Privacidad',
      terms: 'Términos y Condiciones',
      cookies: 'Política de Cookies',
      rights: 'Todos los derechos reservados.',
    },
    // CTA
    cta: {
      readyToTransform: '¿Listo para transformar su espacio?',
      contactUs: 'Contáctenos para una consulta gratuita y descubra todas nuestras soluciones',
      requestConsultation: 'Solicitar Consulta',
      haveProject: '¿Tiene un proyecto en mente?',
      discoverHow: 'Contáctenos para una consulta gratuita y descubra cómo podemos transformar su espacio',
    },
  },
  en: {
    // Header
    nav: {
      inicio: 'Home',
      servicios: 'Services',
      proyectos: 'Projects',
      nosotros: 'About Us',
      contacto: 'Contact',
    },
    // Hero
    hero: {
      title1: 'Orchestrating the',
      title2: 'Invisible',
      subtitle: 'Transforming spaces into intelligent experiences through cutting-edge home automation',
      exploreServices: 'Explore Services',
      viewProjects: 'View Projects',
    },
    // Services
    services: {
      sectionTitle: 'Services Overview',
      title1: 'Orchestrating Your',
      title2: 'Environment',
      subtitle: 'Comprehensive automation solutions that transform your space into an intelligent ecosystem',
      moreInfo: 'More Info',
      viewDetails: 'View Details',
      ourSpecialties: 'Our Specialties',
      allServices: 'All Our Services',
      detailsTitle: 'Service Details',
      moreInformation: 'More Information',
      pageTitle: 'Our Services',
      pageSubtitle: 'Complete home automation solutions for intelligent spaces',
      // Service titles
      service1: 'Integral Projects',
      service2: 'Smart Lighting',
      service3: 'Audiovisual Systems',
      service4: 'Automation & Control',
      service5: 'Private Cinemas',
      // Service descriptions
      service1Desc: 'We develop complete solutions covering all aspects of modern automation.',
      service2Desc: 'We design lighting systems that transform environments and optimize energy consumption.',
      service3Desc: 'We implement cutting-edge entertainment technology that delivers immersive experiences.',
      service4Desc: 'We install home automation systems that centralize control of all elements in your space.',
      service5Desc: 'We create exclusive cinematic experiences in the comfort of your home.',
      // Sub-services
      integratedLighting: 'Integrated Lighting',
      multiZoneAudio: 'Multi-Zone Audio',
      climate: 'Climate Control',
      security: 'Security',
      naturalLight: 'Natural Light',
      colorControl: 'Color Control',
      energySaving: 'Energy Saving',
      smartScenes: 'Smart Scenes',
      homeCinema: 'Home Cinema',
      multiRoomAudio: 'Multi-Room Audio',
      videoStreaming: 'Video Streaming',
      soundDesign: 'Sound Design',
      securitySystem: 'Security System',
      smartLocks: 'Smart Locks',
      climateControl: 'Climate Control',
      smartBlinds: 'Smart Blinds',
      laserProjection: 'Laser Projection',
      dolbyAtmos: 'Dolby Atmos',
      premiumSeats: 'Premium Seats',
      totalControl: 'Total Control',
    },
    // Projects
    projects: {
      sectionTitle: 'Project Portfolio',
      title1: 'Projects that',
      title2: 'Inspire',
      subtitle: 'Discover how we have transformed spaces into intelligent experiences',
      viewAll: 'View All Projects',
      pageTitle: 'Our Projects',
      pageSubtitle: 'Spaces transformed into intelligent experiences',
      all: 'All',
      noProjects: 'No projects in this category',
      projectDescription: 'Project Description',
      brandsUsed: 'Brands Used',
      requestInfo: 'Request Information',
      close: 'Close',
    },
    // About
    about: {
      sectionTitle: 'About Us',
      title1: 'Excellence in',
      title2: 'Automation',
      description: 'With over a decade of experience, we are leaders in high-end home automation solutions.',
      stats: {
        projects: 'Projects',
        experience: 'Years of Experience',
        clients: 'Satisfied Clients',
        support: '24/7 Support',
      },
    },
    // Contact
    contact: {
      sectionTitle: 'Contact',
      title1: "Let's Talk About Your",
      title2: 'Project',
      subtitle: 'We are here to turn your ideas into reality',
      form: {
        name: 'Full Name',
        phone: 'Phone',
        email: 'Email',
        message: 'Message',
        messagePlaceholder: 'Tell us about your project...',
        acceptTerms: 'I accept the terms and conditions and privacy policy',
        acceptMarketing: 'I agree to receive commercial communications',
        submit: 'Send Message',
        sending: 'Sending...',
      },
      info: {
        title: 'Contact Information',
        address: 'Address',
        phone: 'Phone',
        email: 'Email',
        hours: 'Business Hours',
        hoursValue: 'Mon - Fri: 9:00 AM - 6:00 PM',
      },
    },
    // Footer
    footer: {
      description: 'Experts in high-end home automation. We transform spaces into intelligent experiences.',
      quickLinks: 'Quick Links',
      services: 'Services',
      contact: 'Follow Us',
      legal: 'Legal',
      privacy: 'Privacy Policy',
      terms: 'Terms and Conditions',
      cookies: 'Cookie Policy',
      rights: 'All rights reserved.',
    },
    // CTA
    cta: {
      readyToTransform: 'Ready to transform your space?',
      contactUs: 'Contact us for a free consultation and discover all our solutions',
      requestConsultation: 'Request Consultation',
      haveProject: 'Have a project in mind?',
      discoverHow: 'Contact us for a free consultation and discover how we can transform your space',
    },
  },
};

const LanguageContext = createContext();

export const LanguageProvider = ({ children }) => {
  const [language, setLanguage] = useState(() => {
    const saved = localStorage.getItem('language');
    return saved || 'es';
  });

  useEffect(() => {
    localStorage.setItem('language', language);
  }, [language]);

  const t = (key) => {
    const keys = key.split('.');
    let value = translations[language];
    for (const k of keys) {
      value = value?.[k];
    }
    return value || key;
  };

  const toggleLanguage = () => {
    setLanguage(prev => prev === 'es' ? 'en' : 'es');
  };

  return (
    <LanguageContext.Provider value={{ language, setLanguage, toggleLanguage, t }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLanguage = () => {
  const context = useContext(LanguageContext);
  if (!context) {
    throw new Error('useLanguage must be used within a LanguageProvider');
  }
  return context;
};

export default LanguageContext;
